
type Props = {}

const TabDichVuThuoc = (props: Props) => {
  return (
    <div className="h-100 d-flex justify-content-between flex-column">
      <div className='p-2 border h-100'>
        <div className='fw-bold'>Chẩn đoán hình ảnh</div>
        <div>- Siêu âm Doppler tĩnh mạch chậu, chủ dưới</div>
        <div>- Xác định sơ đồ song thị</div>
      </div>
    </div>
  )
}

export default TabDichVuThuoc